import { Engine } from "../Engine";
import { Picker } from "./MouseObjectInteraction";
import { IDrawableObject } from "../Object/ObjectManager";
import { PickingSceneRenderer } from "../Renderer";
import { Camera } from "../View";

export class DefaultPicker implements Picker {
    private pickingRenderer: PickingSceneRenderer;

    constructor(private engine: Engine) {
        this.pickingRenderer = new PickingSceneRenderer();
        this.pickingRenderer.init(engine.ctx);
    }
    pick(camera: Camera, x: number, y: number) : IDrawableObject {
        return this.pickingRenderer.pick(this.engine.activeScene, camera, x, y);
    }
}